import { Type } from '@angular/core';

import { InlineAlertComponent } from './inline-alert.component';

export const INLINE_ALERT_DIRECTIVES: Type<any>[] = [
  InlineAlertComponent
];
